<template>
    <div id="app">
        <app-header/>
        <!--  Large Device  Header-->
        <app-nav class="nav-header"/>

        <!-- Content -->
        <app-layout>
            <router-view></router-view>
        </app-layout>

        <app-footer/>
    </div>
</template>

<script>
    import Header from './components/layout/Header.vue'
    import Footer from './components/layout/Footer.vue'
    import Layout from './components/layout/Layout'

    import NavigationLinks from "./components/NavigationLinks";


    export default {
        name: "app",
        components: {
            "app-header": Header,
            "app-footer": Footer,
            "app-layout": Layout,
            "app-nav": NavigationLinks
        },
        data() {
            return {}
        },
    }
</script>

<style lang="scss">

    @import "assets/main";

    #app {
        font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
    }

    #nav {
        a {
            &.router-link-exact-active {
                color: #42b983;
            }
        }
    }

    .bazz-widget {
        bottom: 68px;
        right: 75px;
        left: auto !important;
    }

    .bazz-widget, .bazz-widget-close, .bazz-widget-form-submit, .bazz-widget-button, .bazz-widget-name-close, .bazz-widget-inner-circle {
        background-color: #a02056;
    }

    .bazz-widget-inner-border, .bazz-widget-form-submit, .bazz-widget-name-close {
        border-color: #a02056;
    }

    .bazz-widget-form-top .countdown {
        color: #a02056;
    }

</style>

<style scoped>
    .nav-header {
        position: sticky;
        top: 0;
        background-color: #fff;
        z-index: 99;
        display: block;
    }

    @media screen and (max-width: 768px){
        .nav-header {
            display: none;
        }
    }
</style>
